// extracted by mini-css-extract-plugin
export default {"blockingArea":"style_blockingArea__yStaG","blockingAreaFooter":"style_blockingAreaFooter__HkU9C"};